(function () {
    'use strict';

    angular
        .module('app.memberAdmin')
        .component('sc3MemberPosting', {
            templateUrl: 'app/member-admin/member-posting/member-posting.component.html',
            controller: AdminScorePostingComponent,
            bindings: { data: '<' }
        });

    AdminScorePostingComponent.$inject = ['$state', '$scope'];
    function AdminScorePostingComponent($state, $scope) {
        var ctrl = this;
        ctrl.redirect = redirect;

        function redirect() {
            $scope.$emit('$userChanged');
            $state.go('member-admin');
        }
    }
})();